import axios from "axios";
import { authHook } from '../services/helper-service';
import { TransactionHistory, AutoProfile, SessionCatalog, Country, Product } from "../types";
export interface ResponseViewModel<T> {
    responseCode: number;
    responseMessage?: string;
    stackTrace?: string;
    payLoad?: T;
    recordCount?: number
}
export class MyAccountService {
    @authHook
    static async initProfile() {
        const result = await axios.get(`/api/myaccount/init-recurring-profile`, {
            withCredentials: true
        });
        return await result.data as ResponseViewModel<{ profile: AutoProfile, countries: Country[] }>;
    }
    static async getCountries() {
        const result = await axios.get(`/api/catalog/countries`, {
            withCredentials: true
        });
        return await result.data as ResponseViewModel<Country[]>;
    }
    static async getProducts(countryCode: string) {
        const result = await axios.get(`/api/catalog/products/${countryCode}`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<{ products: Product[] }>;
    }
    @authHook
    static async fetchRecentTransactionsAndRecurringProfiles() {
        const result = await axios.get(`/api/myaccount/recent-trx-and-profiles`, {
            withCredentials: true,
        });
        const data = await result.data as ResponseViewModel<{
            transactions: TransactionHistory[],
            profiles: AutoProfile[],
            hasMoreTrx: boolean,
            hasMoreProfiles: boolean,
            rewardPointBalance: number,
            storedCardsCount: number
        }>;
        return data;
    }
    @authHook
    static async fetchPurchaseHistory() {
        const result = await axios.get(`/api/myaccount/purchase-history`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<TransactionHistory[]>;
    }
    @authHook
    static async saveSessionByTransactionId(id: number) {
        const result = await axios.post(`/api/trx/save-session-by-trx/${id}`, {}, {
            withCredentials: true
        });
        return await result.data as ResponseViewModel<SessionCatalog>;
    }
    @authHook
    static async fetchPhoneBook() {
        const result = await axios.get(`/api/myaccount/phone-book`, {
            withCredentials: true
        });
        return await result.data as ResponseViewModel<any[]>;
    }
    @authHook
    static async fetchPhoneBookEntry(id: number) {
        const result = await axios.get(`/api/myaccount/phone-book-entry/${id}`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async savePhoneBookEntry(entry: any) {
        const result = await axios.post(`/api/myaccount/save-phone-book-entry`, entry, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async deletePhoneBookEntry(id: number) {
        const result = await axios.post(`/api/myaccount/delete-phone-book-entry/${id}`, {}, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async saveSessionByPhoneBookEntry(id: number) {
        const result = await axios.post(`/api/trx/save-session-by-pbe/${id}?sourceCurrencyCode=USD`, {}, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async fetchTickets() {
        const result = await axios.get(`/api/zendesk/fetchTickets`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any[]>;
    }
    @authHook
    static async fetchComments(ticketId: number) {
        const response = await axios.get(`/api/zendesk/fetchComments/${ticketId}`, {
            withCredentials: true,
        });
        return await response.data as ResponseViewModel<any>;
    }
    @authHook
    static async createTicket(subject: string, body: string, priority: string, type: string) {
        const data = { subject: subject, description: body, priority: priority, type: type };
        const result = await axios.post(`/api/zendesk/createTicket`, data, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async postComment(ticketId: number, comment: string) {
        const data = { ticketId: ticketId, body: comment };
        const result = await axios.post(`/api/zendesk/postComment`, data, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async fetchMyProfile() {
        const result = await axios.get(`/api/myaccount/my-profile`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async saveMyProfile(profile: any) {
        const result = await axios.post(`/api/myaccount/update-profile`, profile, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async fetchRewardPoints() {
        const result = await axios.get(`/api/myaccount/fetch-reward-points`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any[]>;
    }
    @authHook
    static async fetchRecurringProfileList() {
        const result = await axios.get(`/api/myaccount/recurring-profile-list`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any[]>;
    }
    @authHook
    static async changePassword(model: any) {
        const result = await axios.post(`/api/myaccount/change-password`, model, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async fetchRecurringProfile(id: number) {
        const result = await axios.get(`/api/myaccount/fetch-recurring-profile/${id}`, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async createRecurringProfile(model: any) {
        const result = await axios.post(`/api/myaccount/create-recurring-profile`, model, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async continueOn3DSuccess(threeDTrxId: number) {
        //await TopupService.delay(5000);
        const params = new URLSearchParams();
        params.append("id", "" + threeDTrxId);
        const response = await axios.post(`/api/myaccount/continue-on-3d-secure-success`, params, {
            withCredentials: true,
        });
        const dt = response.data as { responseCode: number, responseMessage: string, payLoad: AutoProfile };
        return dt;
    }
    @authHook
    static async cancelRecurringProfile(model: any) {
        const params = new URLSearchParams();
        params.append("id", model.recurringProfileId);
        const result = await axios.post(`/api/myaccount/cancel-recurring-profile`, params, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
    @authHook
    static async fetchStoredCards() {
        const result = await axios.get(`/api/myaccount/fetch-stored-cards`, {
            withCredentials: true
        });
        return await result.data as ResponseViewModel<any[]>;
    }
    @authHook    
    static async deleteStoredCard( id: number ){
        const result = await axios.post(`/api/myaccount/delete-stored-card/${id}`, {}, {
            withCredentials: true,
        });
        return await result.data as ResponseViewModel<any>;
    }
}